"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BurguerMenuLine = exports.BurguerMenu = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject, _templateObject2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var BurguerMenu = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n\n  width: 2rem;\n  height: 1.2rem;\n  cursor: pointer;\n"])));

exports.BurguerMenu = BurguerMenu;

var BurguerMenuLine = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 100%;\n  border: 1px solid #FFF;\n  transition: ", ";\n"])), props => props.theme.burguerMenuTransition);

exports.BurguerMenuLine = BurguerMenuLine;